import script from "./UsersList.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsersList.vue?vue&type=script&lang=ts&setup=true"

import "./UsersList.vue?vue&type=style&index=0&id=6a4cf1b7&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a4cf1b7"]])

export default __exports__